<!-- 登录 -->
<template>
  <div class="wrap">
    <div class="box">
      <div class="left">
        <div class="title">登录</div>
        <el-form
          ref="loginForm"
          :model="params"
          :rules="loginRules"
          label-width="80px"
        >
          <el-form-item label="身份证" prop="idNum">
            <el-input
              v-model="params.idNum"
              placeholder="请输入身份证号"
              @keyup.enter="startLogin"
            ></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input
              type="password"
              v-model="params.password"
              placeholder="请输入密码"
              @keyup.enter="startLogin"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="menus">
          <el-button type="text" @click="changeType(false)">前往注册</el-button>
          <el-button type="primary" @click="startLogin">登录</el-button>
        </div>
      </div>
      <div class="right">
        <div class="title">注册</div>
        <el-form
          ref="registryForm"
          :model="params"
          :rules="registryRules"
          label-width="80px"
        >
          <el-form-item label="身份证" prop="idNum">
            <el-input
              v-model="params.idNum"
              placeholder="请输入身份证号"
              @keyup.enter="startRegistry"
            ></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input
              type="password"
              v-model="params.password"
              placeholder="请输入密码"
              @keyup.enter="startRegistry"
            ></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="confirmPwd">
            <el-input
              type="password"
              v-model="params.confirmPwd"
              placeholder="请确认你的密码"
              @keyup.enter="startRegistry"
            ></el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="code">
            <div class="verify">
              <el-input
                type="number"
                v-model="params.code"
                autocomplete="false"
                @keyup.enter="startRegistry"
              />
              <canvas
                id="code"
                width="100"
                height="40"
                @click="drawCode"
              ></canvas>
            </div>
          </el-form-item>
        </el-form>
        <div class="menus">
          <el-button type="text" @click="changeType(true)">前往登录</el-button>
          <el-button type="primary" @click="startRegistry">完成注册</el-button>
        </div>
      </div>
      <div class="mask" :style="{ left: isLogin ? '50%' : '0' }">
        <img src="@/assets/logo.png" alt="" class="logo" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    const idNumValid = (r, v, cb) => {
      const reg =
        /^\d{6}((((((19|20)\d{2})(0[13-9]|1[012])(0[1-9]|[12]\d|30))|(((19|20)\d{2})(0[13578]|1[02])31)|((19|20)\d{2})02(0[1-9]|1\d|2[0-8])|((((19|20)([13579][26]|[2468][048]|0[48]))|(2000))0229))\d{3})|((((\d{2})(0[13-9]|1[012])(0[1-9]|[12]\d|30))|((\d{2})(0[13578]|1[02])31)|((\d{2})02(0[1-9]|1\d|2[0-8]))|(([13579][26]|[2468][048]|0[048])0229))\d{2}))(\d|X|x)$/;
      if (!reg.test(v)) {
        cb("身份证格式有误");
        return;
      }
      cb();
    };
    const codeValid = (r, v, cb) => {
      if (this.code != v) {
        cb("请输入正确的验证码");
        return;
      }
      cb();
    };
    const confirmPwdValid = (r, v, cb) => {
      if (this.params.password != v) {
        cb("密码不一致!");
        return;
      }
      cb();
    };
    return {
      isLogin: true, // 判断登录状态还是注册状态
      code: "",
      params: {
        idNum: "",
        password: "",
        confirmPwd: "",
        code: "",
      },
      loginRules: {
        idNum: { required: true, message: "请输入身份证", trigger: "blur" },
        password: { required: true, message: "请输入密码", trigger: "blur" },
      },
      registryRules: {
        idNum: [
          { required: true, message: "请输入身份证", trigger: "blur" },
          { validator: idNumValid, trigger: "blur" },
        ],
        password: { required: true, message: "请输入密码", trigger: "blur" },
        confirmPwd: { validator: confirmPwdValid, trigger: "blur" },
        code: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          { validator: codeValid, trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    setTimeout(() => {
      this.drawCode();
    }, 10);
  },
  methods: {
    // 创建验证码数据
    createData() {
      const characters = "0123456789";
      let code = "";
      for (let i = 0; i < 4; i++) {
        let index = Math.floor(Math.random() * characters.length);
        code += characters.charAt(index);
      }
      return code;
    },
    // 绘制验证码
    drawCode() {
      const captchaCanvas = document.getElementById("code");
      const context = captchaCanvas.getContext("2d");
      this.code = this.createData();
      context.clearRect(0, 0, captchaCanvas.width, captchaCanvas.height);
      // 画布
      context.fillStyle = "#e2f4f4"; // 白色
      context.fillRect(0, 0, captchaCanvas.width, captchaCanvas.height);
      // 字体
      context.fillStyle = "#1b7d84";
      context.font = "24px Arial";
      context.fillText(this.code, 20, 30);

      // 绘制干扰线
      for (let i = 0; i < 4; i++) {
        context.beginPath();
        context.moveTo(
          Math.random() * captchaCanvas.width,
          Math.random() * captchaCanvas.height
        );
        context.lineTo(
          Math.random() * captchaCanvas.width,
          Math.random() * captchaCanvas.height
        );
        context.strokeStyle = this.getRandomColor();
        context.stroke();
      }
    },
    // 绘制时的随机颜色
    getRandomColor() {
      var letters = "0123456789ABCDEF";
      var color = "#";
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    changeType(flag) {
      Object.assign(this.$data.params, this.$options.data().params);
      this.isLogin = flag;
      this.$refs.loginForm.clearValidate();
      this.$refs.registryForm.clearValidate();
    },
    // 登录事件
    startLogin() {
      this.$refs.loginForm.validate(async (valid) => {
        if (valid) {
          let res = await this.$api.login(this.params);
          if (res.code == 0) {
            this.$notify.success({ title: "登录成功!" });
            localStorage.setItem("token", res.data.token);
            localStorage.setItem("userInfo", JSON.stringify(res.data));
            // 登录后跳转判断
            const redirectUrl = this.$route.query.redirectUrl;
            if (redirectUrl) {
              this.$router.push(redirectUrl);
            } else {
              this.$router.push("/");
            }
          }
        }
      });
    },
    // 注册事件
    startRegistry() {
      this.$refs.registryForm.validate(async (valid) => {
        if (valid) {
          let res = await this.$api.registry(this.params);
          if (res.code == 0) {
            this.$notify.success({ title: "注册成功!", message: "请前往登录" });
            const account = this.params.idNum;
            setTimeout(() => {
              this.changeType(true);
              this.params.idNum = account;
            }, 500);
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  min-height: calc(100vh - 285px);
  background-color: #e9eaed;
  position: relative;
}
.box {
  width: 800px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 0 10px #ddd;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  overflow: hidden;

  .left,
  .right {
    width: 50%;
    padding: 40px 30px;

    .title {
      text-align: center;
      font-weight: bold;
      font-size: 20px;
      margin-bottom: 30px;
    }
    .menus {
      display: flex;
      justify-content: center;
    }
  }
  .right {
    .verify {
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    #code {
      cursor: pointer;
    }
  }
  .mask {
    width: 50%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background-color: #fff;
    box-shadow: 0 0 5px #ddd;
    display: flex;
    align-items: center;
    transition: 0.5s;

    .logo {
      width: 100%;
    }
  }
}
</style>
